import { SignUp } from "@clerk/react";
import { Link } from "wouter";
import { basePath } from "@/lib/clerk";

export default function SignUpPage() {
  return (
    <div className="min-h-[100dvh] flex flex-col bg-background">
      <div className="absolute inset-0 bg-grid pointer-events-none opacity-50" aria-hidden="true" />
      <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-secondary/40 blur-3xl pointer-events-none" aria-hidden="true" />
      <div className="absolute top-40 -left-32 w-[20rem] h-[20rem] rounded-full bg-primary/20 blur-3xl pointer-events-none" aria-hidden="true" />

      <header className="relative z-10 container mx-auto px-4 h-16 flex items-center">
        <Link href="/" className="font-display font-bold text-xl tracking-tight inline-flex items-baseline gap-1">
          <span>main</span>
          <span className="relative">
            loop
            <span aria-hidden="true" className="absolute -right-2 top-0 w-1.5 h-1.5 rounded-full bg-accent" />
          </span>
        </Link>
      </header>

      <div className="relative z-10 flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-[440px]">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground mb-4 text-center">
            [ STUDENT PORTAL ] · create account
          </div>
          <SignUp
            routing="path"
            path={`${basePath}/sign-up`}
            signInUrl={`${basePath}/sign-in`}
          />
        </div>
      </div>
    </div>
  );
}
